import { Component, OnInit } from '@angular/core'
import { CoreService, TrialService } from '../../services'
import { SchemaUtil, getThumbUrl as imageGetThumbUrl } from '../../utils'
import { File, Product, ProductMove, PurchaseOrderItem } from 'depoto-core/src/entities'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  productsBeforeExpiration: Partial<Product>[] = []
  productsUnderMinimum: Partial<Product>[] = []
  lastMoves: Partial<ProductMove>[] = []
  purchaseOrderItems: Partial<PurchaseOrderItem>[] = []
  canViewPurchaseOrderItems = false

  loading = true

  quantityItemsSum: number[] | number = 0

  constructor(
    private core: CoreService,
    public trialService: TrialService,
  ) {}

  async ngOnInit() {
    await this.getLastMoves()
    await this.getProductsBeforeExpiration()
    await this.getProductsUnderMinimum()
    this.canViewPurchaseOrderItems =
      this.core.services.user.hasRole('ROLE_PURCHASE_ORDER_LIST') &&
      this.core.services.user.user.company.moduleRelations?.some(
        moduleRelation => moduleRelation.module.id === 'purchase-orders',
      )
    if (this.canViewPurchaseOrderItems) {
      await this.fetchPurchaseOrderItems()
    }
  }

  async getLastMoves() {
    await this.core.services.productMovePack
      .getList({ page: 1, sort: 'created', direction: 'desc' }, SchemaUtil.productMovePackList)
      .then(result => {
        this.loading = false
        if (result?.items?.length) this.lastMoves = result?.items.slice(0, 5)
      })
  }

  getQuantityItemsSum(move) {
    if (move.moves?.lenght > 0) return move.moves.map(i => i.amount).reduce((a, b) => Number(a) + Number(b))
    else if (move.moves[0]?.amount > 0) return move.moves[0]?.amount
    else return 0
  }

  async getProductsBeforeExpiration() {
    const productList = await this.core.services.product.getList(
      {
        page: 1,
        sort: 'id',
        direction: 'asc',
        filters: { expirationDateTo: this.getExpirationDateToFilter(), enabled: true },
      },
      SchemaUtil.productList,
    )

    if (productList && productList.items) {
      this.productsBeforeExpiration = productList.items.length > 10 ? productList.items.slice(0, 10) : productList.items
    }
  }

  async getProductsUnderMinimum() {
    const productList = await this.core.services.product.getList(
      {
        page: 1,
        sort: 'id',
        direction: 'asc',
        filters: { metrics: 'less_than_minimum', enabled: true },
      },
      SchemaUtil.productList,
    )

    if (productList && productList.items) {
      this.productsUnderMinimum = productList.items.length > 10 ? productList.items.slice(0, 10) : productList.items
    }
  }

  async fetchPurchaseOrderItems() {
    const result = await this.core.services.purchase.getItemsList(
      {
        filters: {
          status: 'for_stocking',
        },
      },
      SchemaUtil.purchaseOrderItems,
    )
    if (result?.items?.length) {
      this.purchaseOrderItems = result.items
    }
    this.loading = false
  }

  getExpirationDateToFilter(): string {
    const date = new Date()
    date.setMonth(date.getMonth() + 2)
    const tzOffset = date.getTimezoneOffset()
    date.setTime(date.getTime() + tzOffset * 60 * -1000)
    return `${date.toISOString().substring(0, 10)} 23:59:59`
  }

  getThumbUrl(image: File, format: 'w135wp' | 'w2048wp' = 'w135wp'): string {
    return imageGetThumbUrl(image, format)
  }
}
